<template>
	<div v-loading="loading" class="onboarding">
		<div class="onboarding-content">
			<div class="onboarding-content-logo"></div>
			<h1>
				Forgotten password?
			</h1>
			<p v-if="sent">
				Password reset link has been sent to your email.
			</p>
			<el-form v-else :model="form" :rules="rules" ref="form" @submit.prevent.native="handleSubmit('form')">
				<el-form-item prop="email">
					<el-input v-model="form.email" suffix-icon="el-icon-message" placeholder="Email" ref="email"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-between">
						<router-link to="/login">
							<i class="el-icon-arrow-left"></i>Back to login
						</router-link>
						<el-button native-type="submit" type="primary" :loading="loading" plain>Reset</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
	name: 'ForgottenPassword',
	metaInfo () {
		return {
			title: 'Forgotten password'
		}
	},
	data() {
		return {
			api: process.env.VUE_APP_API,
			loading: true,
			sent: false,
			form: {
				email: ''
			},
			rules: {
				email: [
					{ required: true, message: 'Please enter email', trigger: 'blur' },
					{ type: 'email', message: 'Please enter correct email', trigger: 'blur' }
				]
			}
		}
	},
	computed: {
        ...mapState(['auth'])
	},
	mounted () {
		if (this.auth.access_token) {
			this.$router.push('/analytics')
		} else {
			this.$refs.email.focus()
			this.loading = false
		}
	},
	methods: {
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					axios({
						method: 'POST',
						url: this.api + '/api/password/forgot',
						crossdomain: true,
						data: this.form
					})
					.then(() => {
						this.loading = false
						this.sent = true
					})
					.catch(error => {
						this.loading = false
						this.$notify({
							title: 'Error',
							message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
							type: 'error',
							position: 'bottom-right',
							duration: 3500
						})
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
